import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { StyleSheet, css } from 'aphrodite-jss';
import Overlay from './Overlay';
import Container from './Container';
import { bindVars } from './bind-styles';
var styles = StyleSheet.create(bindVars({
  $modalTransitionDuration: '0.3s',
  $transitionCurve: 'cubic-bezier(0.44, 0.11, 0.07, 1.29)',
  modalEnter: {
    opacity: '0',
    '& [data-element="container"]': {
      transform: 'scale(1.3)',
      opacity: '0'
    }
  },
  modalEnterActive: {
    opacity: '1',
    transition: "all $modalTransitionDuration $transitionCurve",
    '& [data-element="container"]': {
      transform: 'scale(1)',
      opacity: '1',
      transition: 'all $modalTransitionDuration $transitionCurve'
    }
  },
  modalExit: {
    opacity: '1',
    '& [data-element="container"]': {
      transform: 'scale(1)',
      opacity: '1'
    }
  },
  modalExitActive: {
    opacity: '0.01',
    transition: 'all $modalTransitionDuration $transitionCurve',
    '& [data-element="container"]': {
      transform: 'scale(1.2)',
      opacity: '0.01',
      transition: 'all $modalTransitionDuration $transitionCurve'
    }
  }
}));

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!document.getElementById('modals-outlet')) {
        var modalsOutlet = document.createElement('div');
        modalsOutlet.id = 'modals-outlet';
        document.body.appendChild(modalsOutlet);
        this.modalsOutlet = modalsOutlet;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isPrevShown = prevProps.isVisible;
      var isVisible = this.props.isVisible;

      if (isPrevShown !== isVisible && !!isVisible) {
        document.body.style.overflow = 'hidden';
      } else if (isPrevShown !== isVisible && !isVisible) {
        document.body.style.overflow = 'initial';
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.modalsOutlet) {
        document.body.removeChild(this.modalsOutlet);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isVisible = _this$props.isVisible,
          children = _this$props.children,
          onClickOverlay = _this$props.onClickOverlay;

      if (this.props.isShown) {
        throw new Error('The prop "isShown" has been replaced by "isVisible"');
      }

      return ReactDOM.createPortal(React.createElement(CSSTransition, {
        in: isVisible,
        timeout: 500,
        mountOnEnter: true,
        unmountOnExit: true,
        classNames: {
          enter: css(styles.modalEnter),
          enterActive: css(styles.modalEnterActive),
          exit: css(styles.modalExit),
          exitActive: css(styles.modalExitActive)
        }
      }, React.createElement(Overlay, {
        onClick: onClickOverlay
      }, React.createElement(Container, null, children))), document.getElementById('modals-outlet'));
    }
  }]);

  return Modal;
}(React.Component);

export default Modal;